import React, { useEffect, useState } from 'react';
import { useSalesRepClients } from '../../../hooks/SalesRep/useSalesRepClients';
import { useNewTicketForm } from '../../../hooks/SalesRep/useNewTicketForm';
import 'react-toastify/dist/ReactToastify.css';
import './SalesRepTickets.css';
import Chip from "../../../components/Chip/Chip";

const serviceOptions = [
    { key: 'PREVENTIVE', value: 'Preventivo' },
    { key: 'INSTALLATION', value: 'Instalación' },
    { key: 'VERIFICATION', value: 'Verificación' },
    { key: 'CORRECTIVE', value: 'Correctivo' },
];

const SalesRepTickets = () => {
    const { clients, loadingClients } = useSalesRepClients();
    const { formState, actions } = useNewTicketForm(clients || []);

    const {
        selectedClient,
        filteredPlants,
        selectedPlant,
        selectedService,
        description,
        additionalComment,
        selectedEquipments,
        filteredEquipments
    } = formState;

    const {
        handleClientChange,
        setSelectedPlant,
        setSelectedService,
        setDescription,
        setAdditionalComment,
        resetForm,
        handleSubmit,
        handleAddEquipment,
        handleRemoveEquipment,
        handlePlantChange,
        loading,
    } = actions;

    const [isConfirmDisabled, setIsConfirmDisabled] = useState(true);

    useEffect(() => {
        const isDisabled = !selectedClient || !selectedPlant || !selectedService || !description;
        setIsConfirmDisabled(isDisabled);
    }, [selectedClient, selectedPlant, selectedService, description]);

    return (
        <div>
            {loading || loadingClients ? (
                <div className="loading-overlay">
                    <div className="spinner"></div>
                    <div className="loading-message">
                        {loading ? 'Guardando...' : 'Obteniendo clientes...'}
                    </div>
                </div>
            ) : (
                <div>
                    <div className="header">
                           <span className="material-icons pencil" aria-label="edit ticket">
                               border_color
                           </span>
                        <div className="header-title">
                            <p>GENERAR TICKET</p>
                        </div>
                    </div>
                    <form className="form-group-sales-rep-tickets" onSubmit={handleSubmit}>
                        <div className="form-item">
                            <label htmlFor="cliente">CLIENTE *</label>
                            <select
                                id="cliente"
                                value={selectedClient}
                                onChange={(e) => handleClientChange(e.target.value)}
                            >
                                <option value="">Seleccionar Cliente</option>
                                {clients?.map((cliente) => (
                                    <option key={cliente.id} value={cliente.id}>
                                        {cliente.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="form-item">
                            <label htmlFor="planta">PLANTA *</label>
                            <select
                                id="planta"
                                value={selectedPlant}
                                onChange={(e) => handlePlantChange(e.target.value)}
                            >
                                <option value="">Seleccionar Planta</option>
                                {filteredPlants.map((planta: any) => (
                                    <option key={planta.id} value={planta.id}>
                                        {planta.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="form-item">
                            <div className="equipment-form-item">
                                <label htmlFor="servicio">EQUIPO(S)</label>
                                <div className="equipment-chips">
                                    {selectedEquipments.map((equipment: any) =>
                                        equipment.components
                                            .filter((component: any) => component.type === "DISPENSER")
                                            .map((dispenser: any) => (
                                                <Chip
                                                    key={equipment.id} // Keeping equipment.id as the key
                                                    text={`${equipment.additive.name} / ${dispenser.uniqueCode}`}
                                                    onRemove={() => handleRemoveEquipment(equipment.id)}
                                                />
                                            ))
                                    )}

                                </div>
                                <select
                                    id="servicio"
                                    value={""}
                                    onChange={(e) => handleAddEquipment(e.target.value)}
                                >
                                    <option value="">Seleccionar Equipo(s)</option>
                                    {filteredEquipments.map((equipment: any) =>
                                        equipment.components
                                            .filter((component: any) => component.type === "DISPENSER")
                                            .map((dispenser: any) => (
                                                <option key={equipment.id} value={equipment.id}>
                                                    {equipment.additive.name} / {dispenser.uniqueCode}
                                                </option>
                                            ))
                                    )}
                                </select>
                            </div>
                        </div>
                        <div className="form-item">
                            <label htmlFor="servicio">SERVICIO *</label>
                            <select
                                id="servicio"
                                value={selectedService}
                                onChange={(e) => setSelectedService(e.target.value)}
                            >
                                <option value="">Seleccionar Servicio</option>
                                {serviceOptions.map((option) => (
                                    <option key={option.key} value={option.key}>
                                        {option.value}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="form-item">
                            <label htmlFor="descripcion">MOTIVO DEL SERVICIO *</label>
                            <textarea
                                id="descripcion"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                            />
                        </div>
                        <div className="form-item">
                            <label htmlFor="comentario">COMENTARIO ADICIONAL</label>
                            <textarea
                                id="comentario"
                                value={additionalComment}
                                onChange={(e) => setAdditionalComment(e.target.value)}
                            />
                        </div>
                        <div className="bottom">
                            <p>* Campos obligatorios</p>
                            <div className="buttons">
                                <button type="button" className="cancel" onClick={resetForm}>
                                    Cancelar
                                </button>
                                <button
                                    type="submit"
                                    className={`confirm ${isConfirmDisabled || loading ? 'disabled' : ''}`}
                                    disabled={isConfirmDisabled || loading}
                                >
                                    Confirmar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            )}
        </div>
    );
};

export default SalesRepTickets;